import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UserRowFragment = { __typename?: 'User', id: string, username: string, roles: any, twoFactorAuthEnabled: boolean };

export type UserDataFragment = { __typename?: 'User', id: string, username: string, roles: any, twoFactorAuthEnabled: boolean, sensorCredentials?: { __typename?: 'SensorCredentials', id: string, username: string, password: string } | null };

export type UserDetailQueryVariables = Types.Exact<{
  id: Types.Scalars['ID'];
}>;


export type UserDetailQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: string, username: string, roles: any, twoFactorAuthEnabled: boolean } | null };

export const UserRowFragmentDoc = gql`
    fragment UserRow on User {
  id
  username
  roles
  twoFactorAuthEnabled
}
    `;
export const UserDataFragmentDoc = gql`
    fragment UserData on User {
  id
  username
  roles
  twoFactorAuthEnabled
  sensorCredentials {
    id
    username
    password
  }
}
    `;
export const UserDetailDocument = gql`
    query UserDetail($id: ID!) {
  user(id: $id) {
    ...UserRow
  }
}
    ${UserRowFragmentDoc}`;

/**
 * __useUserDetailQuery__
 *
 * To run a query within a React component, call `useUserDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserDetailQuery(baseOptions: Apollo.QueryHookOptions<UserDetailQuery, UserDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserDetailQuery, UserDetailQueryVariables>(UserDetailDocument, options);
      }
export function useUserDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserDetailQuery, UserDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserDetailQuery, UserDetailQueryVariables>(UserDetailDocument, options);
        }
export type UserDetailQueryHookResult = ReturnType<typeof useUserDetailQuery>;
export type UserDetailLazyQueryHookResult = ReturnType<typeof useUserDetailLazyQuery>;
export type UserDetailQueryResult = Apollo.QueryResult<UserDetailQuery, UserDetailQueryVariables>;